import script from "./OldHistoryChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./OldHistoryChart.vue?vue&type=script&setup=true&lang=ts"

import "./OldHistoryChart.vue?vue&type=style&index=0&id=95d2667e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95d2667e"]])

export default __exports__